export default __webpack_public_path__ + "maps-examples-data-driven-symbols-thumbnail-960-5b029f9f8d7057dff5f98b90b65613db.png";